// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ICreatePrescriberResponseModel } from './iCreatePrescriberResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CardV1CardV1CreatePrescriberDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': ICreatePrescriberResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CardV1CardV1CreatePrescriberDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "ICreatePrescriberResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return CardV1CardV1CreatePrescriberDefaultResponse.attributeTypeMap;
    }
}
